import { AppConfig } from '@config/app.config';
import { RolesRepository } from '@core/repositories/roles.repository';
import { Permition, Rol } from '@shared/interfaces/rol';
import { Observable, of } from 'rxjs';

interface ResultRoles {
  id: string;
  attributes: {
    name: string;
  };
}

interface ResultRol {
  id: string;
  attributes: {
    name: string;
    description: string;
    permissions: Array<Permition>;
  };
}

export class FakeRolesRepository implements RolesRepository {
  appConfig: AppConfig = new AppConfig();

  dataRoles: Array<ResultRoles> = [
    {
      id: '1',
      attributes: {
        name: 'Administrador'
      }
    },
    {
      id: '2',
      attributes: {
        name: 'Consultor'
      }
    }
  ];

  dataAccess: Array<Permition> = [
    {
      code: 'accounting.attachmenttransactionsevents'
    },
    {
      code: 'accounting.attachmentmastergiros'
    },
    {
      code: 'accounting.attachmentmovementreport'
    },
    {
      code: 'accounting.attachmentbalanceinterface'
    },
    {
      code: 'amlcontrol.add'
    },
    {
      code: 'amlcontrol.delete'
    },
    {
      code: 'amlcontrol.findall'
    },
    {
      code: 'amlcontrol.update'
    },
    {
      code: 'customers.findbydocument'
    },
    {
      code: 'segments.add'
    },
    {
      code: 'segments.delete'
    },
    {
      code: 'segments.findall'
    },
    {
      code: 'segments.findwithoutamllimit'
    },
    {
      code: 'segments.update'
    },
    {
      code: 'transfers.findbycustomerdate'
    },
    {
      code: 'transfers.findbyreference'
    },
    { code: 'transfers.canupdatecellphone' },
    { code: 'transfers.updatecellphone' },
    { code: 'transfers.updatedocument' },
    { code: 'transfers.canavoid' },
    { code: 'transfers.avoid' },
    { code: 'transfers.canreverseadm' },
    { code: 'transfers.reverseadm' },
    { code: 'users.findall' },
    { code: 'users.update' },
    { code: 'users.add' },
    { code: 'users.delete' },
    { code: 'roles.findall' },
    { code: 'roles.update' },
    { code: 'roles.add' },
    { code: 'roles.delete' },
    { code: 'roles.findbyid' },
    { code: 'commissions.findall' },
    { code: 'commissions.update' },
    { code: 'commissions.add' },
    { code: 'commissions.delete' },
    { code: 'accounting.attachmentmodificationlog'},
    { code: 'accounting.attachmenttotalcostsreport'},
    { code: 'accounting.attachmensentinelreport'}
  ];

  dataRol: ResultRol = {
    id: '1',
    attributes: {
      name: 'Administrador',
      description: 'Rol que permite modificar los perfiles del administrador',
      permissions: this.dataAccess
    }
  };

  roles = {
    data: this.dataRoles
  };

  rol = {
    data: this.dataRol
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.roles);
  }

  getItemUser(): Observable<any> {
    // return throwError({
    //   status: 0,
    //   error: { errors: [{ detail: 'Error' }] }
    // });

    return of(this.dataAccess);
  }

  getItemId(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.rol);
  }

  add(rol: Rol): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(rol: Rol): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
